const appConfig = {
    apiPrefix: '/api',
    authenticatedEntryPath: '/app/report/performance',
    authenticatedEntryPathAdminExpert: '/app/report/performance',
    authenticatedEntryPathStandard: '/app/report/performance',
    unAuthenticatedEntryPath: '/sign-in',
    tourPath: '/app/account/kyc-form',
    enableMock: true
}

export default appConfig